import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const EspiraTheme: Theme = createBaseThemeVariation({
    name: 'espira',
    brandColor: 'hsla(357, 60%, 40%, 1)',
});
